import { useState, useEffect, useCallback } from 'react';
import { dashboardService } from '../../../services/dashboard.service';
import type { SummaryStats, RecentData } from '../../../services/dashboard.service';

export function useDashboard() {
  const [stats, setStats] = useState<SummaryStats | null>(null);
  const [recent, setRecent] = useState<RecentData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isLive, setIsLive] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [statsData, recentData] = await Promise.all([
        dashboardService.getSummaryStats(),
        dashboardService.getRecentSubmissions(),
      ]);
      setStats(statsData);
      setRecent(recentData);
    } catch (err: any) {
      setError(err.message || 'Failed to connect. Please ensure the backend is running.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const fetchLiveStatus = async () => {
      try {
        const liveStatus = await dashboardService.getLiveInfo();
        setIsLive(liveStatus);
      } catch (err) {
        setIsLive(false);
      }
    };
    fetchLiveStatus();
    const interval = setInterval(fetchLiveStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  return {
    stats,
    recent,
    loading,
    error,
    isLive,
    refresh: fetchData,
  };
}
